import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { Text, TextLink } from '../../../elements/typography'
import { media } from '../../../style/media'
import commonMsgs from '../../common/messages'
import messages from '../messages'

const AgreeTermsText = styled(Text)`
  text-align: center;
  font-size: ${(props) => props.theme.fontSizes.xsmall}px;
  ${media.sm`
    font-size: ${(props) => props.theme.fontSizes.small}px;
  `};
`

export const AgreeingToTerms = ({ onPressPolicy, onPressTerms }) => (
  <AgreeTermsText>
    <FormattedMessage
      {...messages.acceptTermsAndPolicy}
      values={{
        privacyPolicy: (
          <TextLink onPress={onPressPolicy}>
            <FormattedMessage {...commonMsgs.privacyPolicy} />
          </TextLink>
        ),
        termsOfUse: (
          <TextLink onPress={onPressTerms}>
            <FormattedMessage {...commonMsgs.terms} />
          </TextLink>
        ),
      }}
    />
  </AgreeTermsText>
)
